module.exports = __webpack_public_path__ + "img/komachi onozuka.ebeb3a84.png";